import { NgModule } from '@angular/core';
import { ArticleFilterArchivedPackingUnitsPipe } from './article-filter-archived-packageunits-pipe';
import { ArticleFilterNonStringPackingUnitsPipe } from './article-filter-non-string-packaging-units.pipe';
import { ArticleInventoryTypePipe } from './article-inventoryType-pipe';
import { ArticlePrescriptionTypetPipe } from './articleprescriptiontype-pipe';
import { ArticleStatusPipe } from './articlestatus-pipe';
import { ArticleStatusColorPipe } from './articlestatuscolor-pipe';
import { ArticleUnitPipe } from './articleunit-pipe';
import { AttributeTypePipe } from './attribute-pipe';
import { ProductGroupMngSortPipePipe } from './productgroupsortpipe';
import { ProductGroupTypePipe } from './productgrouptype-pipe';
import { PurchaseRatingPipe } from './purchaserating-pipe';

@NgModule({
  declarations: [
    ProductGroupTypePipe,
    ArticleStatusPipe,
    ArticleStatusColorPipe,
    ArticleUnitPipe,
    ArticlePrescriptionTypetPipe,
    PurchaseRatingPipe,
    ArticleInventoryTypePipe,
    ProductGroupMngSortPipePipe,
    AttributeTypePipe,
    ArticleFilterNonStringPackingUnitsPipe,
    ArticleFilterArchivedPackingUnitsPipe,
  ],
  exports: [
    ProductGroupTypePipe,
    ArticleStatusPipe,
    ArticleStatusColorPipe,
    ArticleUnitPipe,
    ArticlePrescriptionTypetPipe,
    PurchaseRatingPipe,
    ArticleInventoryTypePipe,
    ProductGroupMngSortPipePipe,
    AttributeTypePipe,
    ArticleFilterNonStringPackingUnitsPipe,
    ArticleFilterArchivedPackingUnitsPipe,
  ],
  providers: [ArticleStatusColorPipe, ArticleUnitPipe],
})
export class ArticlePipesModule {}
